"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = exports.LogicalOperator = exports.DateOperator = exports.ArithmeticOperator = exports.ArrayOperator = exports.ArrayComparisonOperator = exports.GenericComparisonOperator = exports.NumberComparisonOperator = void 0;
var NumberComparisonOperator;
(function (NumberComparisonOperator) {
    NumberComparisonOperator["LessThanOrEqual"] = "less_equal";
    NumberComparisonOperator["LessThan"] = "less";
    NumberComparisonOperator["GreaterThanOrEqual"] = "greater_equal";
    NumberComparisonOperator["GreaterThan"] = "greater";
})(NumberComparisonOperator = exports.NumberComparisonOperator || (exports.NumberComparisonOperator = {}));
var GenericComparisonOperator;
(function (GenericComparisonOperator) {
    GenericComparisonOperator["NotEqual"] = "not_equal";
    GenericComparisonOperator["Equal"] = "equal";
})(GenericComparisonOperator = exports.GenericComparisonOperator || (exports.GenericComparisonOperator = {}));
var ArrayComparisonOperator;
(function (ArrayComparisonOperator) {
    ArrayComparisonOperator["In"] = "In";
    ArrayComparisonOperator["NotIn"] = "NotIn";
    ArrayComparisonOperator["HasIntersection"] = "HasIntersection";
    ArrayComparisonOperator["HasNoIntersection"] = "HasNoIntersection";
    ArrayComparisonOperator["Contains"] = "Contains";
    ArrayComparisonOperator["NotContains"] = "NotContains";
    ArrayComparisonOperator["IsSubsetOf"] = "IsSubsetOf";
})(ArrayComparisonOperator = exports.ArrayComparisonOperator || (exports.ArrayComparisonOperator = {}));
var ArrayOperator;
(function (ArrayOperator) {
    ArrayOperator["Filter"] = "Filter";
    ArrayOperator["First"] = "First";
})(ArrayOperator = exports.ArrayOperator || (exports.ArrayOperator = {}));
var ArithmeticOperator;
(function (ArithmeticOperator) {
    ArithmeticOperator["Minus"] = "Minus";
    ArithmeticOperator["Plus"] = "Plus";
})(ArithmeticOperator = exports.ArithmeticOperator || (exports.ArithmeticOperator = {}));
var DateOperator;
(function (DateOperator) {
    DateOperator["DiffDays"] = "DiffDays";
    DateOperator["DiffDaysInclusive"] = "DiffDaysInclusive";
    DateOperator["DiffMilliseconds"] = "DiffMilliseconds";
})(DateOperator = exports.DateOperator || (exports.DateOperator = {}));
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["And"] = "And";
    LogicalOperator["Or"] = "Or";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
exports.Operator = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, NumberComparisonOperator), ArrayComparisonOperator), ArrayOperator), GenericComparisonOperator), DateOperator), LogicalOperator), ArithmeticOperator);
//# sourceMappingURL=operator.model.js.map